export const BONUS_OFFERINGS_APIS = {
  manageBonusOffering: "community/membership/bonus/offerings/manage",
  getOfferingListing: "community/membership/bonus/offerings/paginated/list",
};

export const BONUS_OFFERINGS_PATHNAME = {
  getOfferingListing: (listingUuid) =>
    `community/membership/bonus/offerings/paginated/list?community_offering_uuid=${listingUuid}`,
};
